import type {z} from "zod";

import {ListSupplierFunctionsQueryParams} from "@project/sdk/engineering/zod";

export const listSupplierFunctionsSearchSchema = ListSupplierFunctionsQueryParams.extend({
  page: ListSupplierFunctionsQueryParams.shape.page.catch(1).default(1),
  perPage: ListSupplierFunctionsQueryParams.shape.perPage.catch(20).default(20),
  q: ListSupplierFunctionsQueryParams.shape.q.catch(undefined),
  state: ListSupplierFunctionsQueryParams.shape.state.catch("ACTIVE"),
  sortKey: ListSupplierFunctionsQueryParams.shape.sortKey.catch("supplierFunctionId"),
  sortDir: ListSupplierFunctionsQueryParams.shape.sortDir.catch("asc").default("asc"),
});

export type ListSupplierFunctionsSearchInput = z.input<typeof listSupplierFunctionsSearchSchema>;
export type ListSupplierFunctionsSearch = z.output<typeof listSupplierFunctionsSearchSchema>;
